export const formatRODate = (value) => {
    if (!value) return "—";

    if (typeof value === "string") {
        // normalizáljuk az ISO-t (mert 7 digitet ad vissza)
        value = value.replace(/\.\d+Z?$/, "Z");
    }

    const d = new Date(value);
    if (isNaN(d.getTime())) return value;

    return d.toLocaleString("ro-RO", {
        hour12: false,
        timeZone: "Europe/Bucharest",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    });
};
